import useRecurringRules, { RecurringRule, TakerMarketWithRecurringRule } from './useRecurringRules';
import useTakerMarkets, { OfferSchedule, TakerMarket } from './useTakerMarkets';

export interface TakerMarketWithAutomation {
  takerMarket: TakerMarket;
  automation: {
    invoiceRule?: RecurringRule;
    offerSchedule?: OfferSchedule;
  };
}

const transformAutomationQueryData = (
  recurringRulesQueryData: TakerMarketWithRecurringRule[] | null,
  takerMarkets: TakerMarket[]
): TakerMarketWithAutomation[] => {
  const invoiceRules = recurringRulesQueryData ?? [];

  if (takerMarkets.length === 0) {
    return [];
  }

  const takerMarketsWithAutomations = takerMarkets.map((takerMarket) => {
    const takerMarketWithRecurringRule = invoiceRules.find(
      (r) =>
        r.takerMarket.marketUuid === takerMarket.marketUuid &&
        r.takerMarket.takerDivisionUuid === takerMarket.takerDivisionUuid
    );

    const invoiceRule = takerMarketWithRecurringRule?.rule;

    return {
      takerMarket,
      automation: {
        invoiceRule,
        offerSchedule: takerMarket.offerSchedule,
      },
    } satisfies TakerMarketWithAutomation;
  });

  return takerMarketsWithAutomations.filter((takerMarketWithAutomation) => {
    const { automation } = takerMarketWithAutomation;

    // Return true if automation has any defined properties
    return Object.values(automation).some((value) => value !== undefined);
  });
};

const useAutomations = (): TakerMarketWithAutomation[] => {
  const { data: takerMarkets = [] } = useTakerMarkets();
  const recurringInvoiceRules = useRecurringRules();

  return transformAutomationQueryData(recurringInvoiceRules, takerMarkets);
};

export default useAutomations;
